import { render } from "./BuyInsManager.vue?vue&type=template&id=002e1ef7&scoped=true"
import script from "./BuyInsManager.vue?vue&type=script&lang=js"
export * from "./BuyInsManager.vue?vue&type=script&lang=js"

import "./BuyInsManager.vue?vue&type=style&index=0&id=002e1ef7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javon\\mgs\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-002e1ef7"]])

export default __exports__